<template>
  <el-dialog :visible.sync="dialogVisible" center width="600px" height="360px" @closed="cancleDialog" :show-close="false"
    :close-on-click-modal="false" title="补充用户信息" custom-class="update-dialog" append-to-body>

    <div class="register-form">
      <el-form :model="updateUserForm" :rules="rules" ref="updateUserForm" label-width="60px">
        <el-form-item label="昵称" prop="nickName">
          <el-input v-model="updateUserForm.nickName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="行业" prop="profession">
          <el-input v-model="updateUserForm.profession" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="单位" prop="archivesLocation">
          <el-input v-model="updateUserForm.archivesLocation" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('updateUserForm')" class="update-btn">提交</el-button>
        </el-form-item>
      </el-form>
    </div>

  </el-dialog>

</template>
<script>
import {
  register,
  captchaImage,
  updateUserProfile
} from "@/api/index";
import {
  mapState,
  mapActions
} from "vuex";
export default {
  props: {
    regDialogVisible: {
      default: false,
    },

  },
  data() {
    // 密码复杂度验证
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'));
      }
      // 密码必须包含大小写字母和数字
      const hasUpperCase = /[A-Z]/.test(value);
      const hasLowerCase = /[a-z]/.test(value);
      const hasNumber = /[0-9]/.test(value);

      if (!hasUpperCase || !hasLowerCase || !hasNumber) {
        return callback(new Error('密码必须包含大小写字母和数字'));
      }

      if (value.length < 8) {
        return callback(new Error('密码长度不能少于8位'));
      }

      callback();
    };

    // 手机号验证规则
    const validatephonenumber = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号'));
      }
      const reg = /^1[3-9]\d{9}$/;
      if (!reg.test(value)) {
        return callback(new Error('请输入正确的手机号'));
      }
      callback();
    };

    // 图形验证码验证规则
    const validateCaptcha = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入图形验证码'));
      }
      // if (value.length !== 4) {
      //   return callback(new Error('验证码长度为4位'));
      // }
      callback();
    };

    return {
      isEdit: false,
      dialogVisible: this.regDialogVisible,
      updateUserForm: {
        nickName: '',
        profession: '',
        archivesLocation: ''
      },
      rules: {
        nickName: [
          { required: true, message: '请输入', trigger: 'blur' },
          { min: 3, max: 16, message: '长度在 3 到 16 个字符', trigger: 'blur' }
        ],
        profession: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        archivesLocation: [
          // { required: false, message: '请输入', trigger: 'blur' }
        ]
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.login.userInfo,
    }),
  },
  mounted() {
    // this.updateUserForm = {
    //   nickName: this.userInfo?.nickName,
    //   profession: this.userInfo?.profession,
    //   archivesLocation: this.userInfo?.archivesLocation
    // }
    
  },
  watch: {
    regDialogVisible: function (dialogVisible) {
      this.dialogVisible = dialogVisible;
          this.updateUserForm = {
      nickName: this.userInfo?.nickName,
      profession: this.userInfo?.profession,
      archivesLocation: this.userInfo?.archivesLocation
    }

    }
  },
  methods: {

    // 提交表单
    submitForm(formName) {
      // 更新用户信息
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updateUserProfile(this.updateUserForm).then(response => {
            if (response.code === 200) {
              // this.$message.success('基本信息保存成功');
					this.$router.push('/ai');

 
            } else {
              this.$message.error(response.msg);

            }
            this.isEditing = false;
          }).catch(error => {
            this.$message.error(error.message);
          });

        } else {
          console.log('表单验证失败');
          return false;
        }
      });
    },

    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    changeDialog() {
      this.$emit("scDialog", { showdialog: false, showLog: true });
      this.dialogVisible = false;
    },

    cancleDialog() {
      this.$refs["updateUserForm"].resetFields();
      this.dialogVisible = false;
    },


  },
};
</script>
<style lang="scss" scoped>
.update-btn{
  width: 100%;
}
::v-deep .update-dialog {

border-radius: 20px;
  max-width: 600px;
  width: 90% !important; // 移动端自适应

  .el-dialog__body {
    padding: 20px;
  }

  .register-form {
    .el-form-item {
      margin-bottom: 22px;
    }

 
  }
}

@media screen and (max-width: 768px) {
  ::v-deep .update-dialog {
    width: 95% !important;

    .el-form-item__label {
      width: 80px !important;
    }

    .el-form-item__content {
      margin-left: 80px !important;
    }

 
  }
}
</style>